import { Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { sortBy } from 'lodash';
import { Subscription } from 'rxjs';
import { MessengerService } from './messenger.service';

@Injectable({
  providedIn: 'root'
})
export class AuditService implements OnDestroy
{
  public revisionTypes: Array<{ text: string; key: string; value: number }> = [
    { text: 'Create', key: 'CREATE-TYPE-AUDIT', value: 0 },
    { text: 'Update', key: 'UPDATE-TYPE-AUDIT', value: 1 },
    { text: 'Delete', key: 'DELETE-TYPE-AUDIT', value: 2 }
  ];

  private messagingLanguageChangedSubscription: Subscription;

  constructor(translate: TranslateService, messengerService: MessengerService)
  {
    this.loadLocalizations(translate);
    this.messagingLanguageChangedSubscription = messengerService.receiveMessage().subscribe({
      next: (message) =>
      {
        if (message && message.type && message.type === 'languageChanged')
        {
          this.loadLocalizations(translate);
        }
      }
    });
  }

  public ngOnDestroy(): void
  {
    if (this.messagingLanguageChangedSubscription !== undefined) { this.messagingLanguageChangedSubscription.unsubscribe(); }
  }

  /**
   * Get the revision type description to use
   *
   * @param revisionType Revision Type
   * @returns string Revision Type description
   */
  public getRevisionTypeText(revisionType: number): string
  {
    let text = revisionType.toString();
    const revision = this.revisionTypes.find(x => x.value === revisionType);
    if (revision !== undefined)
    {
      text = revision.text;
    }
    return text;
  }

  /**
   * Load localizations
   */
  private loadLocalizations(translate: TranslateService): void
  {
    // Set the audit types from localization
    const auditTypesTranslationKeys = this.revisionTypes.map(a => a.key);
    translate.get(auditTypesTranslationKeys).subscribe({
      next: (res: string) =>
      {
        for (let i = 0; i < this.revisionTypes.length; i++)
        {
          this.revisionTypes[i].text = res[this.revisionTypes[i].key];
        }
        this.revisionTypes = sortBy(this.revisionTypes, ['text']);
      }
    });
  }
}
